import { render, staticRenderFns } from "./ManageGroups.vue?vue&type=template&id=78588614&scoped=true&"
import script from "./ManageGroups.vue?vue&type=script&lang=js&"
export * from "./ManageGroups.vue?vue&type=script&lang=js&"
import style0 from "./ManageGroups.vue?vue&type=style&index=0&id=78588614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78588614",
  null
  
)

export default component.exports